import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/counties', params);
};

export const show = (id, params = {}) => {
  return axios.get(`/counties/${id}`, params);
};

export const create = (payload) => {
  return axios.post('/counties', payload);
};

export const update = (id, payload) => {
  return axios.put(`/counties/${id}`, payload);
};

export const destroy = (id) => {
  return axios.delete(`/counties/${id}`);
};
